<app-top-bar title="PAYMENT.PAY_CARD" [customBack]="cancel"></app-top-bar>

<div class="content">
  <div [id]="buttonsContainerId" class="widget-container"></div>
  <div [id]="screenContainerId" class="widget-container payment-screen"></div>

  @if (loading) {
    <div class="loader-container">
      <mat-spinner class="loader"></mat-spinner>
      <p>{{ 'PAYMENT.PROGRESS' | translate }}</p>
    </div>
  }
</div>
